(function () {
  if (window.__rrProductV2Ready) return;
  window.__rrProductV2Ready = true;

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-rr-rec-prev], [data-rr-rec-next]');
    if (!arrow) return;

    var root = arrow.closest('.rr-pdp-related[data-rr-related]');
    var grid = root && root.querySelector('[data-rr-rec-grid]');
    var first = grid && grid.firstElementChild;
    if (!grid || !first) return;

    var styles = window.getComputedStyle(grid);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    var direction = arrow.hasAttribute('data-rr-rec-prev') ? -1 : 1;
    grid.scrollBy({
      left: (first.getBoundingClientRect().width + gap) * direction,
      behavior: 'smooth',
    });
  });
})();
